<template>
  <div id="app">
    <app-header></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
    <SocialChat icon class="whatsapp-chat" :attendants="attendants">
      <p slot="header">
        Feel Free To Contact
      </p>
      <!-- <MyWhatsAppIcon slot="button" /> -->
    </SocialChat>
  </div>
</template>

<script>
import appHeader from "./components/General/header";
import appFooter from "./components/General/footer";

export default {
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Robust Office",
    // all titles will be injected into this template
    // titleTemplate: "%s | My Awesome Webapp",
  },
  data() {
    return {
      attendants: [
        {
          app: "whatsapp",
          label: "Technical support",
          name: "Muhammad Musab",
          number: "00923070301064",
          avatar: {
            src: require("./assets/images/home/team/member2.png"),
            alt: "Alan Ktquez avatar",
          },
        },
        // ...
      ],
    };
  },
  components: {
    appHeader,
    appFooter,
  },
};
</script>

<style>
.whatsapp-chat {
  --whatsapp: #aa4a30;
  --vsc-bg-header: var(--whatsapp);
  --vsc-bg-button: var(--whatsapp);
  --vsc-outline-color: var(--whatsapp);
}
</style>
